
import { useEffect, useMemo, useState } from 'react';
import { ENABLE_TIMEFILTER, ENABLE_AUTO_ASN_COUNTRY } from '../../../utils/settings';


export const useTimeFilter = (graphData, setFilteredGraphData, setCaseChanges) => {
  const [timeFilter, setTimeFilter] = useState(() => {
    const from = new Date();
    const to = new Date(from);
    from.setUTCMonth(from.getUTCMonth() - 6);
    // set month works with negative months, but doesn't work going from march31 to feb28. it goes to march 3. this fixes this issue:
    if ((12 + to.getUTCMonth() - from.getUTCMonth()) % 12 === 5) from.setUTCDate(0);
    from.setUTCHours(0, 0, 0, 0);
    to.setUTCHours(23, 59, 59, 999);
    return { from: from.getTime(), to: to.getTime() };
  });
  const [filterDefaultGrouping, setFilterDefaultGrouping] = useState({country: false, asn: false});

  useEffect(() => {
    const fnodes = [];
    const fedges = [];
    if (!ENABLE_TIMEFILTER) {
      setFilteredGraphData(graphData);
      return;
    }
    if (!graphData.nodes || !graphData.edges) {
      setFilteredGraphData({ ...graphData, nodes: fnodes, edges: fedges });
      return;
    }

    // console.log("Filtering: ", graphData)

    const { from, to } = timeFilter;
    const tsInMilliseconds = (ts) => (ts > 2000000000 ? ts : Math.floor(ts * 1000));
    const infoElementFilter = (infoElement) => {
      // console.log("FILTERING ", infoElement);
      if (!isNaN(infoElement.timestamp)) {
        let ts = tsInMilliseconds(infoElement.timestamp);
        return (from <= ts && ts <= to);
      }
      for (let tsInt of infoElement.timestamp) {
        if (tsInt.length === 2 && tsInt[0] === -1 && tsInt[1] === -1) return true;
        for (let tsPoint of tsInt) {
          const tsPointMs = tsInMilliseconds(tsPoint);
          if (from <= tsPointMs && tsPointMs <= to) return true;
        }
        if (tsInt.length === 2 && tsInMilliseconds(tsInt[0]) <= from && from <= tsInMilliseconds(tsInt[1])) return true;
      }
      return false;
    };
    const nodesThatHaveEdges = {}; // [type][value] = 1
    const markNodeHasEdge = (type, value) => {
      if (!(type in nodesThatHaveEdges)) nodesThatHaveEdges[type] = {};
      nodesThatHaveEdges[type][value] = 1;
    }

    for (let edge of graphData.edges) {
      const fedge = { ...edge, info: [] };
      if (!edge.info) continue;
      if (ENABLE_AUTO_ASN_COUNTRY) {
        if ((edge.from_type === 'country' || edge.to_type === 'country') && !(filterDefaultGrouping?.country)) continue;
        if ((edge.from_type === 'asn' || edge.to_type === 'asn') && !(filterDefaultGrouping?.asn)) continue;
      }
      
      for (let info of edge.info) {
        const finfo = { ...info, content: info.content.filter(infoElementFilter) };
        if (finfo.content.length > 0) fedge.info.push(finfo);
      }
      if (fedge.info.length > 0) {
        fedges.push(fedge);
        markNodeHasEdge(fedge.from_type, fedge.from_value);
        markNodeHasEdge(fedge.to_type, fedge.to_value);
      }
    }

    for (let node of graphData.nodes) {
      if (node.type === 'country' && !(filterDefaultGrouping?.country)) continue;
      if (node.type === 'asn' && !(filterDefaultGrouping?.asn)) continue;
      const fnode = { ...node, info: [] };
      for (let info of (node.info || [])) {
        const finfo = { ...info, content: info.content.filter(infoElementFilter) };
        if (finfo.content.length > 0) fnode.info.push(finfo);
      }
      if (fnode.info.length > 0 || fnode.manuallyAdded || fnode.trace || nodesThatHaveEdges[fnode.type]?.[fnode.value]) {
        fnodes.push(fnode);
      }
    }

    setFilteredGraphData({ ...graphData, nodes: fnodes, edges: fedges });
  }, [graphData, timeFilter, filterDefaultGrouping, setFilteredGraphData]);

  useEffect(() => {
    setCaseChanges(true);
  }, [timeFilter, setCaseChanges]);

  return {
    timeFilter,
    setTimeFilter,
    filterDefaultGrouping,
    setFilterDefaultGrouping
  }
}
